import CompanySuspendModal from './CompanySuspendModal';

export default CompanySuspendModal;
